<script lang="ts" setup>
import { useAuthStore } from '@kidzonet/pinia/UserStore'
import CommonLayer from '@kidzonet/vue3-common-layer/src/CommonLayer/index.vue'
import { MainMenuInterface } from '@kidzonet/vue3-common-layer/src/types'

interface RouterRootProps {
    root: string
    menu: MainMenuInterface[]
}

defineProps<RouterRootProps>()

const store = useAuthStore()
await store.fetchUserInfo()
</script>

<template>
    <CommonLayer
        :menu="menu"
        :root="root"
    >
        <template #before-logo>
            <slot name="before-logo" />
        </template>
        <template #logo>
            <slot name="logo" />
        </template>
    </CommonLayer>
</template>

<style>
    .app-content {
        padding: calc(1em + 64px) 2em 1em;
    }
</style>
